export default __webpack_public_path__ + "static/intro-w-moto-a85a86abfea76c2252cacb1ba1b0184d.svg";